export const DELIVERY_PROGRESS_COLOR = Styles.color.primary;
